"use client";

import RadioButton_1 from "./RadioButton_1";
// import { updateUserVisibility } from "@/actions/updateUserVisibility";
import { useRouter, useSearchParams } from "next/navigation";
export default function RadioButtonSocialFeedSwitch({
  defaultChecked
}) {

  const router = useRouter()
  const searchParams = useSearchParams()

  const feedPreference = searchParams.get('feed')

  const handleChange = async (arg) => {
 
    router.push(`?feed=${arg.feed}`)
    // payload looks like: { forum_visibility: "PUBLIC" }
//     await updateUserVisibility(payload);
  };

  return (
    <RadioButton_1
      caption1="All"
      caption2="Following"
      value1="all"
      value2="following"
      defaultChecked={feedPreference || 'all'}
      callback={handleChange}
      callbackObjectKey="feed"
    />
  );
}